import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Storage } from '@ionic/storage-angular';
import { IdNameModel } from './web-api-client';
// import { IdNameModel } from '../../../../ComidaQS.WebApp/dist/comidaqs-services/lib/web-api-client';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  organizations: IdNameModel[] = [];
  currentOrganization: IdNameModel = <IdNameModel>{};

  organizationsSubject: BehaviorSubject<IdNameModel[]> = new BehaviorSubject<IdNameModel[]>([]);
  currentOrganizationSubject: BehaviorSubject<IdNameModel> = new BehaviorSubject<IdNameModel>(<IdNameModel>{});

  public accessToken: string;
  
  constructor(
    private storage: Storage
  ) { }

  getOrganizations() {
    this.storage.get('qs_orgs').then(data => {
      this.organizations = data;
      this.organizationsSubject.next(this.organizations);
    });

    return this.organizationsSubject;
  }

  setOrganizations(organizations: IdNameModel[]) {
    this.storage.set('qs_orgs', organizations);
    this.organizations = organizations;

    this.organizationsSubject.next(this.organizations);
  }

  getCurrentOrganization() {
    this.storage.get('qs_last_org').then(data => {
      this.currentOrganization = data;
      this.currentOrganizationSubject.next(this.currentOrganization);
    });

    return this.currentOrganizationSubject;
  }

  setCurrentOrganization(organization: IdNameModel) {
    this.storage.set('qs_last_org', organization);
    this.currentOrganization = organization;
    localStorage.setItem('qs_last_org', organization.id);
    this.currentOrganizationSubject.next(this.currentOrganization);
  }

  public get currentOrganizationValue(): string {
    return this.currentOrganizationSubject.value?.id;
  }
}
